import {
  Directive,
  inject,
  Injector,
  Input,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';

@Directive({
  selector: '[h3Injector]',
  standalone: false,
})
export class InjectorDirective implements OnInit {
  @Input('h3Injector') injector!: Injector;

  private templateRef = inject(TemplateRef<any>);
  private viewContainer = inject(ViewContainerRef);

  ngOnInit() {
    this.viewContainer.createEmbeddedView(this.templateRef, undefined, {
      injector: this.injector,
    });
  }
}
